import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import ru from './locales/ru.json';

// Russian is the default and ships in the main bundle. English is a separate
// chunk loaded only when chosen: with the menu, quick-start and help texts
// translated (UX-12) it added ~17 KB gzip to every first load, including
// the majority of clients who never switch the language.
const resources = {
  ru: { translation: ru }
};

// Явный `lng` отключает детектор целиком: выбор в переключателе языка
// сохранялся в localStorage и на следующей загрузке молча сбрасывался в ru.
// Уважаем сохранённый выбор, по умолчанию по-прежнему русский.
const storedLng = (() => {
  try { return localStorage.getItem('i18nextLng'); } catch { return null; }
})();

export const loadEnglish = () => {
  if (i18n.hasResourceBundle('en', 'translation')) return Promise.resolve();
  return import(/* webpackChunkName: "locale-en" */ './locales/en.json').then((mod) => {
    // `added` re-renders every component using translations (bindI18nStore below).
    i18n.addResourceBundle('en', 'translation', mod.default || mod, true, true);
  });
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    partialBundledLanguages: true,
    lng: ['en', 'ru'].includes(storedLng) ? storedLng : 'ru', // Russian by default
    fallbackLng: 'ru',
    supportedLngs: ['en', 'ru'],
    debug: false,
    interpolation: {
      escapeValue: false
    },
    react: {
      bindI18n: 'languageChanged',
      bindI18nStore: 'added',
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

// Some text lives in index.html, before React mounts: the "skip to content" link and the
// install banner. React never renders it, so the language is applied here.
const STATIC_HTML_TEXT = {
  ru: {
    skip: 'Перейти к содержимому',
    installTitle: 'Установить TrafficForge',
    installText: 'Добавьте на главный экран для быстрого доступа',
    later: 'Позже',
    install: 'Установить',
  },
  en: {
    skip: 'Skip to main content',
    installTitle: 'Install TrafficForge',
    installText: 'Add it to your home screen for quick access',
    later: 'Later',
    install: 'Install',
  },
};

const applyStaticHtmlLanguage = (lng) => {
  try {
    const text = STATIC_HTML_TEXT[lng] || STATIC_HTML_TEXT.ru;
    const set = (selector, value) => {
      const el = document.querySelector(selector);
      if (el) el.textContent = value;
    };
    set('.skip-to-content', text.skip);
    set('#pwa-install-banner strong', text.installTitle);
    set('#pwa-install-banner p', text.installText);
    set('#pwa-dismiss-btn', text.later);
    set('#pwa-install-btn', text.install);
    document.documentElement.setAttribute('lang', lng);
  } catch {
    /* no DOM (tests) */
  }
};
applyStaticHtmlLanguage(i18n.language);

if (i18n.language === 'en') {
  loadEnglish();
}
i18n.on('languageChanged', (lng) => {
  if (lng === 'en') loadEnglish();
  applyStaticHtmlLanguage(lng);
});

export default i18n;
